export default function ensureStringIsWrapped(s, wrapper) {
    let startWrapper;
    let endWrapper;
    if (Array.isArray(wrapper)) {
        startWrapper = wrapper[0] || '';
        endWrapper = wrapper[1] || startWrapper;
    }
    else {
        startWrapper = wrapper;
        endWrapper = wrapper;
    }
    if (s.startsWith(startWrapper) && s.endsWith(endWrapper))
        return s;
    return startWrapper + s + endWrapper;
}
